import React, { useEffect, useState } from 'react';
import { getServices } from '../api';

export default function StepService({ onSelect }) {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getServices()
            .then(setServices)
            .catch(() => setServices([]))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <div className="loading"><div className="spinner" /></div>;
    }

    if (!services.length) {
        return (
            <div className="loading">
                <p>Нет доступных сервисов</p>
            </div>
        );
    }

    return (
        <div>
            <div className="section-title">Выберите услугу</div>
            {services.map(svc => (
                <div
                    key={svc.id}
                    className="service-card"
                    onClick={() => onSelect(svc)}
                >
                    <h3>{svc.name}</h3>
                    {svc.description && <p>{svc.description}</p>}
                </div>
            ))}
        </div>
    );
}
